// src/pages/home/index.jsx

import React from 'react';
import {
    Container,
    Row,
    Col,
    Form,
    FormLabel,
    FormControl,
    Button
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useForm } from 'react-hook-form';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';

import useToken from '../hooks/useToken';
import sectionTopBg from '../assets/images/section-top.webp';
import { API_ENDPOINTS } from '../utils/config';

const ContactForm = () => {
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm();

    const { token } = useToken();

    const handleFormSubmit = async (formData) => {
        try {
            await sendContactRequest(formData);
            toast.success('Form submitted successfully!', toastOptions);
            reset();
        } catch (error) {
            toast.error(`Submission failed: ${error.message}`, toastOptions);
            console.error('Form submission error:', error);
        }
    };

    const sendContactRequest = async (formData) => {
        const payload = {
            ...formData,
            subject: 'Contact Us - Jinesh P.V'
        };

        const headers = {
            'Content-Type': 'multipart/form-data; charset=UTF-8',
            Authorization: `Bearer ${token}`
        };

        const response = await axios.post(API_ENDPOINTS.CONTACT_FORM_ENDPOINT, payload, { headers });

        if (response.data.status !== 'mail_sent') {
            throw new Error(response.data.message || 'Unknown error occurred');
        }

        toast.success(response.data.message, toastOptions);
    };

    const toastOptions = {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light'
    };

    return (
        <section id="contact-form" className="section inner-page">
        <div
            className="section-decoration top"
            style={{
            backgroundImage: `url(${sectionTopBg})`,
            height: '35px',
            backgroundColor: '#f8f9fa'
            }}
        />
        <Container>
            <Row>
                <Col className="mx-auto col-12 col-md-8 col-lg-8">
                    <h2 className="text-7 fw-500 mb-4 pb-2 mt-5 wow fadeInUp text-dark">
                    Let's get in touch
                    </h2>

                    <Form className="form-border" onSubmit={handleSubmit(handleFormSubmit)}>
                        <Row className="g-4">
                            <Col xs={12}>
                                <FormLabel htmlFor="your_name">
                                    What is your name<span className="required">*</span>
                                </FormLabel>
                                <FormControl
                                    id="your_name"
                                    type="text"
                                    className="py-1 fw-500 fs-6"
                                    {...register('yourName', {
                                    required: 'Name is required',
                                    maxLength: { value: 50, message: 'Max 50 characters allowed' }
                                    })}
                                />
                                {errors.yourName && (
                                    <span className="text-error">{errors.yourName.message}</span>
                                )}
                            </Col>

                            <Col xs={12}>
                                <FormLabel htmlFor="email">
                                    Your email address<span className="required">*</span>
                                </FormLabel>
                                <FormControl
                                    id="email"
                                    type="email"
                                    className="py-1 fw-500 fs-6"
                                    {...register('emailAddress', {
                                    required: 'Email is required',
                                    pattern: {
                                        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                        message: 'Invalid email format'
                                    }
                                    })}
                                />
                                {errors.emailAddress && (
                                    <span className="text-error">{errors.emailAddress.message}</span>
                                )}
                            </Col>

                            <Col xs={12}>
                                <FormLabel htmlFor="form-message">
                                    Your message<span className="required">*</span>
                                </FormLabel>
                                <FormControl
                                    as="textarea"
                                    rows={4}
                                    id="form-message"
                                    className="py-1 fw-500 fs-6"
                                    {...register('message', {
                                    required: 'Message is required',
                                    maxLength: { value: 500, message: 'Max 500 characters allowed' }
                                    })}
                                />
                                {errors.message && (
                                    <span className="text-error">{errors.message.message}</span>
                                )}
                            </Col>

                            <Col xs={12} className="text-center text-lg-start">
                                <Button variant="dark" type="submit" className="rounded-2 cbtn position-relative" id="submit-btn">
                                    Send{' '}
                                    <FontAwesomeIcon icon={faArrowRight} />
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </Container>
        <ToastContainer />
        </section>
    );
};

export default ContactForm;
